module.exports = __webpack_public_path__ + "img/oneImg.92fc5661.92fc5661.png";